export default "__VITE_ASSET__01d12ff9__"